import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Card = withViewportStyle("div")`
  display: inline-block;
  width: 100%;
  max-width: ${rem(288)};
  margin: ${rem(32)} ${rem(12)};

  ${(props) => props.$viewport.mobile`
    max-width: ${rem(343)};
  `}
`;

export const Content = styled.div`
  display: grid;
  justify-items: start;
  gap: ${rem(8)};
`;

export const Media = withViewportStyle("img")`
  display: block;
  width: ${rem(288)};
  height: ${rem(288)};
  object-fit: cover;
  border-radius: ${rem(16)};

  ${(props) => props.$viewport.mobile`
    width: 100%;
    height: ${rem(343)};
  `}
`;

export const Actions = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${rem(20)};
`;
